import { CSSProperties } from 'react';

import { useTheme } from 'styled-components';

import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons/index';
import { RoomExpediaPriceDetailViewModel } from '@api/index';
import { getCurrencySymbol } from '@utils/utils';
import Tooltip from '@components/ui/Tooltip/next';

import {
  FeeDetailsItem,
  FeeDetailsWrapper,
  FeeDetailsLabel,
  FeeDetailsDueHotelLabel,
  Separator,
  Title,
} from './DetailsStyle';

export interface FeeDetailsProps {
  openFeeDetails?: boolean;
  toggleOpenFeeDetails?: React.Dispatch<React.SetStateAction<boolean>>;
  feeDetails?: RoomExpediaPriceDetailViewModel;
  buttonStyle?: CSSProperties;
}

const FeeDetails = (props: FeeDetailsProps) => {
  const { palette } = useTheme();

  const { feeDetails, buttonStyle } = props;

  return (
    <div>
      <Tooltip
        overlayInnerStyle={{
          lineHeight: 1.43,
          textAlign: 'left',
          minWidth: '184px',
        }}
        placement='topRight'
        title={
          <div>
            <FeeDetailsItem>
              <Title>{feeDetails?.title} tutarı (Vergi Dahil)</Title>
              <span>
                {feeDetails?.total.toFixed(2)}{' '}
                {getCurrencySymbol(
                  feeDetails?.currency || feeDetails?.originalCurrency
                )}
              </span>
            </FeeDetailsItem>

            <FeeDetailsDueHotelLabel>
              Şehir vergisi otelde ödenir
            </FeeDetailsDueHotelLabel>

            {feeDetails?.mandatoryTax ? (
              <FeeDetailsItem>
                <span>Şehir Vergisi </span>
                <span>
                  {feeDetails?.mandatoryTax}{' '}
                  {getCurrencySymbol(
                    feeDetails?.originalCurrency || feeDetails?.currency
                  )}
                </span>
              </FeeDetailsItem>
            ) : null}
          </div>
        }
      >
        <FeeDetailsWrapper style={buttonStyle}>
          <Separator />
          <CustomIcon icon={InfoIcon} fontSize={16} fill={palette.NL800} />
          <FeeDetailsLabel>Ücret Detayları</FeeDetailsLabel>
        </FeeDetailsWrapper>
      </Tooltip>
    </div>
  );
};

export default FeeDetails;
